import {
  MeasurementParameter,
  MeasurementUnitKey,
} from '../../types/interfaces/user-measurement';

export const MEASUREMENT_UNITS_BY_PARAMETER: Record<
  MeasurementParameter,
  MeasurementUnitKey[]
> = {
  weight: ['UM_unitKg', 'UM_unitLb'],
  height: ['UM_unitCm', 'UM_unitIn'],
};

export const DEFAULT_MEASUREMENT_UNIT_BY_PARAMETER: Record<
  MeasurementParameter,
  MeasurementUnitKey
> = {
  weight: 'UM_unitKg',
  height: 'UM_unitCm',
};

export const MEASUREMENT_UNIT_SELECTOR_ENABLED = false;

export function getSelectableUnitsForParameter(
  parameter: MeasurementParameter,
): MeasurementUnitKey[] {
  if (!MEASUREMENT_UNIT_SELECTOR_ENABLED) {
    return [DEFAULT_MEASUREMENT_UNIT_BY_PARAMETER[parameter]];
  }

  return MEASUREMENT_UNITS_BY_PARAMETER[parameter];
}
